import Cookie from 'js-cookie';

function toJsCookieAttributes(opts) {
  // currently properties are identical, but this is more typesafe and future proof if we ever swap
  // out to another cookie library
  return {
    domain: opts.domain,
    expires: opts.expires,
    path: opts.path,
    secure: opts.secure
  };
}

function setItem(key, val) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (val == null) {
    Cookie.remove(key);
  } else {
    Cookie.set(key, val, toJsCookieAttributes(options));
  }
}

function getItem(key) {
  return Cookie.get(key) || null;
}

function removeItem(key) {
  Cookie.remove(key);
}

var cookieStorage = {
  setItem: setItem,
  getItem: getItem,
  removeItem: removeItem
};
export default cookieStorage;
//# sourceMappingURL=cookie-storage.js.map